import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Make sure you have react-toastify installed & set up

const RisingStarAdd = () => {
  const navigate = useNavigate();

  const initialFormState = {
    discount: '',
    product:"",
    current_price:"",
    old_price:"",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [risingStarImage, setRisingStarImage] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);

  // Handle text input (discount)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file inputs (both image and logo)
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === 'image') {
      setRisingStarImage(file);
      setPreviewImage(URL.createObjectURL(file));
    } else if (type === 'logo') {
      setBrandLogo(file);
      setPreviewLogo(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiFormData = new FormData();
    apiFormData.append('product', formData.product);
    apiFormData.append('current_price', formData.current_price);
    apiFormData.append('old_price', formData.old_price);
    apiFormData.append('discount', formData.discount);
    if (risingStarImage) apiFormData.append('rising_star_image', risingStarImage);
    if (brandLogo) apiFormData.append('brand_logo', brandLogo);

    try {
      const response = await axios.post(
        'https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_risingstar',
        apiFormData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      console.log("API Response:", response.data);

      // ✅ Check for success (true boolean)
      if (response.data.success === true) {
        toast.success(response.data.message || 'Rising Star added successfully!');

        // Reset form
        setFormData(initialFormState);
        setRisingStarImage(null);
        setBrandLogo(null);
        setPreviewImage(null);
        setPreviewLogo(null);

        console.log("Navigation triggered ✅");
        navigate('/Rising', { replace: true });
      } else {
        toast.error(response.data.message || 'Failed to add Rising Star');
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Something went wrong!');
    }
  };;



  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Add Deals</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Top Deals</a></li>
            <li className="breadcrumb-item active">Add</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">New Top Deals</h4>
            </div>
            <div className="card-body row">
              {/* Main Image */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'rising_star_image')}
                  required
                />
                {previewImage && (
                  <img src={previewImage} alt="Preview" height="80" className="mt-2" />
                )}
              </div>

              {/* Brand Logo */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'logo')}
                  required
                />
                {previewLogo && (
                  <img src={previewLogo} alt="Logo Preview" height="80" className="mt-2" />
                )}
              </div>

              {/* Product */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Product Name</label>
                <input
                  type="text"
                  name="product"
                  value={formData.product}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Product Name"
                  required
                />
              </div>

              {/* Current Price */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Current Price</label>
                <input
                  type="text"
                  name="current_price"
                  value={formData.current_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Current Price"
                  required
                />
              </div>

              {/* Discount */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., Up To 50% Off"
                  required
                />
              </div>

              {/* Old Price */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Old Price</label>
                <input
                  type="text"
                  name="old_price"
                  value={formData.old_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Old Price"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary">
                Save Top Deals
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RisingStarAdd;